export const adjustUserProfiles = profile => {
  const user = profile && profile.userId;
  const role = profile && profile.roleId;
  const companyData = profile && profile.companyId;
  const company = {
    id: companyData && companyData.companyId,
    nameLegal: companyData && companyData.nameLegal,
    inn: companyData && companyData.inn,
    subjectId: companyData && companyData.subjectId,
    subjectKey:
      companyData && companyData.subjectId && companyData.subjectId.subjectKey,
  };
  if (company && company.subjectKey === 'physical') {
    company.userName = '';
    company.userName += companyData.lastname ? `${companyData.lastname} ` : '';
    company.userName += companyData.name ? `${companyData.name[0]}.` : '';
    company.userName += companyData.patronymic
      ? `${companyData.patronymic[0]}.`
      : '';
  }
  return {
    profile: {
      image: user && user.photo,
      id: profile && profile.profileId,
      user: {
        name: user && user.name,
        lastname: user.lastname,
        patronymic: user.patronymic,
      },
      role: {
        role: role && role.role,
        roleId: role && role.roleId,
        roleKey: role && role.roleKey,
      },
      company,
      lastActivity: profile.lastActivity,
    },
  };
};
